<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="ticketsrepository.icon" class="mr-1"></i>
            {{ ticketsrepository.title }}
            <!-- {{ daterange }} -->
            <span v-if="eventtitle"> for {{ eventtitle }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-3">
          <b-card-body class="py-0">
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Issue Date" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="issued_at" v-model="issued_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="issued_at = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Type" label-for="type" label-cols="12">
                  <!-- <b-input-group
                    class="treeselect_all justify-content-end pr-2px"
                  >
                    <span
                      style="padding-top: 0.3em"
                      class="text-primary"
                      id="original-tooltip"
                      >Original</span
                    >
                    <b-form-checkbox
                      id="original"
                      v-model="isoriginal"
                      class="z-0"
                    >
                    </b-form-checkbox>
                  </b-input-group> -->
                  <treeselect v-model="type" :clearable="true" :multiple="true" :options="options_type"
                    placeholder="Show all..."></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." searchPromptText="Type at least 4 chars..."
                    v-model="eventcode" :clearable="true" :multiple="true" :async="true"
                    :load-options="treeselect_loadEvent" :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested @select="treeselect">
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="slaclike-tooltip">Like</span>
                    <b-form-checkbox id="slaclike" v-model="slaclike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!slaclike_visible">
                    <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="slac"
                      :clearable="true" :multiple="true" :async="true" :load-options="treeselect_loadSLAC"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested :disabled="readonly">
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
                <!-- <b-form-group
                  label-cols="12"
                  label="SL A/C (LIKE %)"
                  label-size="sm"
                > -->
                <b-input-group v-if="slaclike_visible">
                  <b-form-input v-model="slaclike" :debounce="ticketsrepository.debounce"
                    placeholder="Client SL A/C (LIKE %)" trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!slaclike" @click="slaclike = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <!-- </b-form-group> -->
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="GDS Locator ( Paste List )" label-for="reflist2" label-cols="12">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="reflist2-tooltip">VLocator</span>
                    <b-form-checkbox id="isvendorlocator" v-model="isvendorlocator" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist2" v-model="locator" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Locator" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <!-- placeholder="Enter transaction refs separated by space, comma or semicolon" -->
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="locator = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Ticket No" label-for="reflist1" label-cols="12">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <!-- <label
                      style="padding-top: 0.3em"
                      :class="
                        options_outbound.length > 0
                          ? 'text-primary mr-2'
                          : 'mr-2'
                      "
                      >Found: {{ options_outbound.length }},
                    </label> -->
                    <span style="padding-top: 0.3em" class="text-primary" id="reflist1-tooltip">Related?</span>
                    <b-form-checkbox id="related_ticketno" v-model="isrelated" class="z-0">
                    </b-form-checkbox>
                    <span style="padding-top: 0.3em" class="text-primary" id="islive-tooltip">Live Only</span>
                    <b-form-checkbox id="islive_ticketno" v-model="islive" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>

                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist1" v-model="ticketno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref (333..,333...)" size="sm" class="h-29" add-button-text="+" add-on-change
                      remove-on-delete add-button-variant="outline-primary"></b-form-tags>

                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="ticketno = []">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
                <b-tooltip target="reflist1-tooltip" triggers="hover">Use ticket number in related fields? Check this
                  option to see
                  associated exchange and re-issued tickets.
                </b-tooltip>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name / Item" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="passenger" placeholder="Name" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!passenger" @click="passenger = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>



              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker size="sm" v-model="datetravel" label-help hide-header locale="en-GB"
                      placeholder="Date Travel" :debounce="ticketsrepository.debounce" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"></b-form-datepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!datetravel" @click="datetravel = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Routing" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="routing" placeholder="Routing" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!routing" @click="routing = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                
                  <b-col v-if="permissionvalid('systems.development') || user.department == 'ACCOUNTS' || user.department == 'F1'">
                    <b-form-group label-cols="12" label="Airline Code" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="carrier_id" placeholder="Airline Code" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!carrier_id"
                            @click="carrier_id = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Date Travel" label-size="sm">
                  <b-input-group>
                    <daterangepicker size="sm" ref="travel_at" v-model="travel_at" :opens="'right'"
                      :locale-data="locale_data" :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="true"
                      :single-date-picker="'range'">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="travel_at = {
                        startDate: null,
                        endDate: null,
                      }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col> <b-form-group label-cols="12" label="Flight No" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="flightno" placeholder="Flight No" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!flightno" @click="flightno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group></b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Class" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="classid" placeholder="Class" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!classid" @click="classid = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="RI Line" label-size="sm">
                  <!-- <span id="emptyriline-tooltip">Empty?</span>
                    <b-form-checkbox id="emptyriline" v-model="emptyri" class="z-0">
                    </b-form-checkbox> -->
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <b-form-checkbox-group id="inventorytype" v-model="inventory_type" :options="options_inventory_type"
                      size="sm" value-field="id" text-field="label" name="radio-options" class="z-0"
                      style="padding-top: 0.2em">
                    </b-form-checkbox-group>
                  </b-input-group>
                  <b-input-group>
                    <b-form-input v-model="line_ri" placeholder="RI Line" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!line_ri" @click="line_ri = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label="Fare Type" label-for="fare_type" label-cols="12">
                      <treeselect v-model="fare_type" :clearable="true" :multiple="true" :options="options_fare_type"
                        placeholder="Show all..."></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Fare Indicators" label-for="fare_indicators" label-cols="12">
                      <treeselect v-model="fare_indicators" :clearable="true" :multiple="true"
                        :options="options_fare_indicators" placeholder="Show all..."></treeselect>
                    </b-form-group>
                  </b-col>

                </b-row>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Invoice No? ( Paste List )" label-for="reflist" label-cols="12"> <b-input-group
                    class="treeselect_all justify-content-end pr-2px">
                    <b-form-checkbox-group id="isinvoiced" v-model="isinvoiced" :options="options_isinvoiced" size="sm"
                      value-field="id" text-field="label" name="radio-options" class="z-0" style="padding-top: 0.2em">
                    </b-form-checkbox-group>
                  </b-input-group>
                  <b-input-group class="z-0">
                    <b-form-tags input-id="reflist" v-model="invoiceno" tag-variant="primary" separator=" ,;"
                      placeholder="Paste Ref (IA519826,IA519827,...)" size="sm" class="h-29" add-button-text="+"
                      add-on-change remove-on-delete add-button-variant="outline-primary"></b-form-tags>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="invoiceno = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Notes" label-for="notes" label-cols="12">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <b-form-checkbox-group id="hasnotes" v-model="hasnotes" :options="options_hasnotes" size="sm"
                      value-field="id" text-field="label" name="radio-options" class="z-0" style="padding-top: 0.2em">
                    </b-form-checkbox-group>
                  </b-input-group>
                  <b-input-group class="z-0">
                    <b-form-input v-model="notes" placeholder="Notes" trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="notes = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">

                <b-form-group label="Invoicing In-Tray" label-for="inventory_type" label-cols="12">
                  <treeselect v-model="inventory_type" :clearable="true" :multiple="false"
                    :options="options_inventory_type" placeholder="Show all..."></treeselect>
                </b-form-group>
              </b-col> -->



              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>

                  <b-col>
                    <b-form-group label-cols="12" label="Agent" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="agent" placeholder="Agent" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="!agent" @click="agent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group> </b-form-group></b-col>
                  <b-col>
                    <b-form-group label="PCC" label-for="branch" label-cols="12">
                      <treeselect v-model="branch" :clearable="true" :multiple="true" :options="options_branch"
                        placeholder="Show all..."></treeselect>
                    </b-form-group>
                  </b-col>

                </b-row>

              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label="Exceptions" label-for="state" label-cols="12">
                      <treeselect v-model="state" :clearable="true" :multiple="true" :options="options_state"
                        placeholder="Show all..."></treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col>
                    <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm" class="mb-0">
                      <b-input-group>
                        <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                          v-model="blac" :clearable="true" :multiple="true" :async="true"
                          :load-options="treeselect_loadBLAC" :show-count="true" :flatten-search-results="true"
                          :disable-branch-nodes="true" :matchKeys="['id']" search-nested :disabled="readonly">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <div class="px-3">
          <!-- {{ ticketsrepository.selectall }}
          {{ ticketsrepository.selected.length }} -->
          <d-table classdivtable="availtable datatable" refid="ticketsrepository" :icon="ticketsrepository.icon"
            :toolbarlibrary="ticketsrepository.toolbarlibrary" :tools="ticketsrepository.tools"
            :badges="ticketsrepository.badges" :fields="ticketsrepository.fields" :items="ticketsrepository.items"
            :downloaded="ticketsrepository.downloaded" :busy="ticketsrepository.busy" :offset="ticketsrepository.offset"
            :limit="ticketsrepository.limit" :page="ticketsrepository.page" :showpages="true"
            @load="ticketsrepository_load" @click="ticketsrepository_click" @select="ticketsrepository_select">
          </d-table>
        </div>
      </div>
      <div v-show="component">
        <component :is="component" :selection="ticketsrepository.selected" :intray="inventory_type" :config="cconfig"
          @discard="ticketsrepository_click('discard')"></component>
        <!-- @refresh="ticketsrepository_click('refresh')" -->
      </div>
      <!-- {{ ticketsrepository.selected.length }}
      {{ ticketsrepository.selected }} -->
      <b-row class="px-3">
        <b-col>
          <b-alert :show="message ? true : false" variant="success">
            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
              <b-col>
                <span v-html="message"></span></b-col></b-row>
          </b-alert></b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import ETRView from "./Components/ETRView";
import ETREmail from "./Components/ETREmail";
import TicketEdit from "./Components/TicketEdit";
import TicketNotes from "./Components/TicketNotes";
import TicketsSync from "./Components/TicketsSync";
import TicketsErrors from "./Components/TicketsErrors";
import TicketsInvoice from "./Components/TicketsInvoice";
import TicketsPG from "./Components/TicketsPG.vue";
import TicketsDraft from "./Components/TicketsDraft";
import TicketsChange from "./Components/TicketsChange";
import TicketsAmend from "./Components/TicketsAmend";
import TicketsAssign from "./Components/TicketsAssign";
import TicketImport from "./Components/TicketImport";

export default {
  name: "TicketsRepository",
  components: {
    ETRView,
    ETREmail,
    TicketEdit,
    TicketNotes,
    TicketsSync,
    TicketsErrors,
    TicketsInvoice,
    TicketsPG,
    TicketsDraft,
    TicketsChange,
    TicketsAmend,
    TicketsAssign,
    TicketImport
  },
  async mounted() {
    this.accessdenied();
    await this.ticketsrepository_load(0);

    let data = await this.$helpers.getsystemsetting("pnr_pcc");
    if (data) {
      this.options_branch = JSON.parse(data);
    }
  },
  watch: {
    async issued_at() {
      await this.ticketsrepository_load(0);
    },
    async flightno() {
      await this.ticketsrepository_load(0);
    },
    async isrelated() {
      await this.ticketsrepository_load(0);
    },
    async isvendorlocator() {
      await this.ticketsrepository_load(0);
    },
    async islive() {
      await this.ticketsrepository_load(0);
    },
    async passenger() {
      await this.ticketsrepository_load(0);
    },
    async line_ri() {
      await this.ticketsrepository_load(0);
    },
    async emptyri() {
      await this.ticketsrepository_load(0);
    },
    async slaclike_visible() {
      await this.ticketsrepository_load(0);
    },
    async routing() {
      await this.ticketsrepository_load(0);
    },
    async carrier_id() {
      await this.ticketsrepository_load(0);
    },
    async slac() {
      await this.ticketsrepository_load(0);
    },
    async blac() {
      await this.ticketsrepository_load(0);
    },
    async slaclike() {
      await this.ticketsrepository_load(0);
    },
    async ticketno() {
      if (this.ticketno.length > 0) {
        this.issued_at = { startDate: null, endDate: null }
        this.islive = false
        await this.ticketsrepository_load(0);
      } else {
        this.issued_at = { startDate: this.$moment().startOf("month").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
        this.islive = true
      }
    },
    async locator() {
      if (this.locator.length > 0) {
        this.issued_at = { startDate: null, endDate: null }
        await this.ticketsrepository_load(0);
      } else {
        this.issued_at = { startDate: this.$moment().startOf("month").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
    },
    async invoiceno() {
      if (this.invoiceno.length > 0) {
        this.issued_at = { startDate: null, endDate: null }
        await this.ticketsrepository_load(0);
      } else {
        this.issued_at = { startDate: this.$moment().startOf("month").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
    },
    async hasnotes() {
      await this.inventorylines_load(0);
    },

    async notes() {
      console.log('watch notes')
      if (this.notes.length > 0) {
        this.issued_at = { startDate: null, endDate: null }
        this.hasnotes = ["1"]

      } else {
        this.hasnotes = ["0"]
        this.issued_at = { startDate: this.$moment().startOf("year").format("YYYY-MM-DD"), endDate: this.$moment().format("YYYY-MM-DD") }
      }
      await this.inventorylines_load(0);
    },
    async classid() {
      await this.ticketsrepository_load(0);
    },
    async travel_at() {
      await this.ticketsrepository_load(0);
    },
    async eventcode() {
      await this.ticketsrepository_load(0);
    },
    async agent() {
      await this.ticketsrepository_load(0);
    },
    async branch() {
      await this.ticketsrepository_load(0);
    },
    async isqueued() {
      await this.ticketsrepository_load(0);
    },
    async type() {
      await this.ticketsrepository_load(0);
    },
    async fare_type() {
      await this.ticketsrepository_load(0);
    },
    async fare_indicators() {
      await this.ticketsrepository_load(0);
    },
    async state() {
      await this.ticketsrepository_load(0);
    },
    async isinvoiced() {
      await this.ticketsrepository_load(0);
    },
    async inventory_type() {
      switch (this.inventory_type) {
        case "ticketfee":
        case "priced":
          this.type = ["ticket"];
          this.isinvoiced = false;
          break;
        default:
          this.type = [];
          this.isinvoiced = null;
      }
      await this.ticketsrepository_load(0);
    },
    "window.width": {
      immediate: true,
      async handler(newVal, oldVal) {

        let state = this.ticketsrepository;

        // HIDE COLUMNS BELOW WIDTH
        if (newVal < 1500) {
          // state.fields[11].class = "d-none"
          // state.fields[12].class = "d-none"
        } else {
          // state.fields[11].class = "text-center"
          // state.fields[12].class = "text-center"
        }
        if (newVal < 1800) {
          state.fields[9].class = "d-none"
          state.fields[10].class = "d-none"
          state.fields[11].class = "d-none"

          state.fields[20].class = "d-none"
          state.fields[21].class = "d-none"

        } else {
          state.fields[9].class = "text-center"
          state.fields[10].class = "text-center"
          state.fields[11].class = "text-center"

          state.fields[20].class = "text-center"
          state.fields[21].class = "text-center"
        }
      },
    },
  },
  data() {
    return {
      busy: false,
      readonly: false,
      message: null,
      issued_at: {
        startDate: this.$moment().startOf("month").format("YYYY-MM-DD"),
        endDate: this.$moment().format("YYYY-MM-DD"),
      },
      ticket: null,
      // datetravel: null,
      travel_at: {
        startDate: null,
        endDate: null,
      },
      ticketno: [],
      invoiceno: [],
      blac: [],
      slac: [],
      slaclike: null,
      slaclike_visible: null,
      passenger: null,
      line_ri: null,
      emptyri: null,
      routing: null,
      carrier_id: null,
      classid: null,
      locator: [],
      eventcode: [],
      agent: null,
      flightno: null,
      type: ["charter", "emd", "lowcost", "ticket", "reissue"],
      fare_type: [],
      fare_indicators: [],
      branch: [],
      state: [],
      options_state: [
        { id: "errors", label: "Errors" },
        { id: "warnings", label: "Warnings" },
      ],
      // iserror: null,
      isqueued: null,
      isinvoiced: null,
      isrelated: false,
      isvendorlocator: false,
      islive: true,
      // options_islive: [{ id: true, label: "Live Ticket Only" }],
      // options_iserror: [
      //   { id: true, label: "Yes" },
      //   { id: false, label: "No" },
      // ],
      hasnotes: [],
      options_hasnotes: [
        { id: '1', label: 'Yes' },
        { id: '0', label: 'No' },
      ],
      notes: null,
      inventory_type: null,
      options_inventory_type: [
        { id: "ticketfee", label: "Fee" },
        { id: "priced", label: "Priced" },
        { id: "empty", label: "Empty?" },
        // { id: "z-hold", label: "Z-Hold" },
      ],
      options_isinvoiced: [
        { id: true, label: "Yes" },
        { id: false, label: "No" },
      ],
      options_type: [
        { id: "charter", label: "Charter" },
        { id: "emd", label: "EMD" },
        { id: "lowcost", label: "Lowcost" },
        { id: "ticket", label: "Ticket" },
        { id: "reissue", label: "Reissue" },
        { id: "refund", label: "Refund" },
        { id: "void", label: "Void" },
      ],
      options_fare_type: [
        { id: "manual", label: "Manual" },
        { id: "negotiated", label: "Negotiated" },
        { id: "net", label: "Net" },
        { id: "private", label: "Private" },
        { id: "published", label: "Published" },
        { id: "unknown", label: "Unknown" },
        { id: "private-ch", label: "Private-ch" },
        { id: "mixed-ch", label: "Mixed-ch" },
      ],

      options_fare_indicators: [
        { id: "cat35fare", label: "Cat35Fare" },
        { id: "negotiatedfare", label: "NegotiatedFare" },
        { id: "netvalues", label: "NetValues" },
        { id: "governmentapproval", label: "GovernmentApproval" },
        { id: "inclusivetourfare", label: "InclusiveTourFare" },
        { id: "itbfare", label: "ITBFare" },
        { id: "bulktourfare", label: "BulkTourFare" },
      ],
      options_branch: [
        // // AMR1
        // { id: "17TK", label: "17TK | AMR" },
        // // FOP2
        // { id: "8GHJ", label: "8GHJ | FOM" },
        // // MBM1
        // { id: "36GI", label: "36GI | MERCEDES" },
        // { id: "00XJ", label: "00XJ | MONSPRT" },
        // // MP4
        // { id: "4T5I", label: "4T5I | MCLAREN" },
        // { id: "3MRK", label: "3MRK | PIRELLI" },
        // // REN11
        // { id: "36RI", label: "36RI | ALPINE" },
        // { id: "4P1I", label: "4P1I | TP" },
        // { id: "18IK", label: "18IK | TPTEST" },
        // // WIL1
        // { id: "36NI", label: "36NI | WILLIAMS" },
        // { id: "Q3RL", label: "Q3RL | FORTESCUE" },
      ],
      ticketsrepository: {
        title: "Tickets",
        icon: "fa fa-ticket text-orange",
        debounce: 1500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        selectall: false,
        toolbarlibrary: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-ticket text-orange",
            position: "toolbar,actions",
            action: "etrview",
            label: "Ticket",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-envelope text-primary",
            position: "toolbar,actions",
            action: "etremail",
            label: "Email",
            labelprop: "emailed_at",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-commenting-o",
            position: "toolbar",
            action: "notes",
            label: "Notes",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-times-circle text-danger",
            position: "toolbar",
            action: "errors",
            label: "PNR States",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-exchange",
            position: "toolbar",
            action: "sync",
            label: "PNR Sync",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-life-ring text-danger",
            position: "toolbar",
            action: "postgres",
            label: "Old Tickets",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-times-circle text-danger",
            position: "toolbar",
            action: "mark0",
            label: "Mark 0",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-repeat text-primary",
            position: "toolbar",
            action: "amend",
            label: "Amend",
            component: {
              name: "",
            },
          },
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-share text-info",
            position: "toolbar",
            action: "assign",
            label: "Assign",
            component: {
              name: "",
            },
          },
        ],
        //postgres
        tools:
          "go,filter,import,download,clipboard,errors,sync,amend,edit,deleteconfirm,assign,invoice,etremail,etrview",
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-50px",
          },
          {
            key: "issued_at",
            label: "Issued",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm");
              }
              return result;
            },
          },
          {
            key: "type",
            label: "Type",
            sortable: true,
            class: "text-center",
          },
          {
            key: "locator",
            label: "Locator",
            sortable: true,
            class: "text-center",
          },
          {
            key: "carrier_id",
            label: "Al",
            sortable: true,
            class: "d-none d-xl-table-cell text-center",
          },

          {
            key: "ticketno",
            label: "Ticket No",
            sortable: true,
            class: "text-center",
          },
          {
            key: "passenger",
            label: "Name",
            sortable: true,
            class: "d-none d-sm-table-cell",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 20) {
                  result = result.slice(0, 17) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "datetravel",
            label: "Date Travel",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "routing",
            label: "Routing",
            sortable: true,
            class: "text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 13) {
                  result = result.slice(0, 12) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "flightno",
            label: "FlightNo",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
            formatter: (value, key, item) => {
              let result = value;
              if (result) {
                if (result.length > 14) {
                  result = result.slice(0, 14) + "...";
                }
              }
              return result;
            },
          },
          {
            key: "class",
            label: "Class",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
          },
          // {
          //   key: "seatno",
          //   label: "Seat",
          //   sortable: true,
          //   class: "d-none d-lg-table-cell text-center",
          //   formatter: (value, key, item) => {
          //     let result = value;
          //     if (result) {
          //       if (result.length > 7) {
          //         result = result.slice(0, 7) + "...";
          //       }
          //     }
          //     return result;
          //   },
          // },
          // {
          //   key: "fare_type",
          //   label: "Fare Type",
          //   sortable: true,
          //   class: "text-center",
          // },
          {
            key: "fee",
            label: "Fee",
            sortable: true,
            class: "d-none d-lg-table-cell text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "fare",
            label: "Fare",
            sortable: true,
            class: "d-none d-lg-table-cell text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "tax",
            label: "Tax",
            sortable: true,
            class: "d-none d-lg-table-cell text-right",
            totalled: true,
            total: 0,
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "text-center",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "text-center",
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
          },
          {
            key: "invoiceno",
            label: "InvoiceNo",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
          },
          {
            key: "branch",
            label: "PCC",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
          },
          // {
          //   key: "lines",
          //   label: "#Sec",
          //   sortable: true,
          // },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "d-none d-lg-table-cell text-center",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-130px",
          },
        ],
        badges: [
          {
            key: "carrier_id",
            type: "pill",
            class: "white",
          },
          {
            key: "ticketno",
            type: "pill",
            class: "orange",
          },
          {
            key: "class",
            type: "pill",
            class: "purple",
            title: "classname",
          },
          {
            key: "locator",
            type: "pill",
            class: "secondary",
          },
          {
            key: "lines",
            type: "pill",
            class: "white",
          },
          {
            key: "type",
            type: "badge",
            Charter: "teal",
            Ticket: "primary",
            Reissue: "primary",
            Void: "white",
            Refund: "white",
            EMD: "purple",
            Lowcost: "pink",
            ADMA: "primary",
            ACMA: "danger",
            SPDR: "primary",
            SPCR: "danger",
          },
          {
            key: "fare_type",
            type: "badge",
            Unknown: "white",
            Negotiated: "warning",
            Net: "purple",
            Manual: "secondary",
            Published: "white",
            Private: "pink",
            other: "secondary",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case "Unknown":
                  return "Unknown";
                  break;
                case "Negotiated":
                  return "Negotiated";
                  break;
                case "Net":
                  return "Net";
                  break;
                case "Manual":
                  return "Manual";
                  break;
                case "Published":
                  return "Published";
                  break;
                case "Private":
                  return "Private";
                  break;
                default:
                  return value;
              }
            },
          },
          {
            key: "queued",
            type: "badge",
            Yes: "danger",
            No: "info",
            formatter: (value, key, item) => {
              if (value == true) {
                return "Yes";
              } else if (value == false) {
                return "No";
              } else {
                return "";
              }
            },
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  methods: {
    accessdenied() {
      this.ticketsrepository.denied = [];
      if (!this.user.permissions.includes("tickets.pnrsync")) {
        this.ticketsrepository.denied.push("sync");
        this.ticketsrepository.denied.push("errors");
      }
      if (!this.user.permissions.includes("tickets.blackhole")) {
        this.ticketsrepository.denied.push("postgres");
        // this.ticketsrepository.denied.push("inledgers");
        // this.ticketsrepository.denied.push("routefix");
        // this.ticketsrepository.denied.push("charterfix");
      }

      if (!this.user.permissions.includes("tickets.delete")) {
        this.ticketsrepository.denied.push("delete");
      }
      if (!this.user.permissions.includes("tickets.save")) {
        this.ticketsrepository.denied.push("save");
        this.ticketsrepository.denied.push("amend");
      }
      if (!this.user.permissions.includes("tickets.invoice")) {
        this.ticketsrepository.denied.push("submit");
      }
      if (!this.user.permissions.includes("salesledger.save") && !this.user.permissions.includes("boughtledger.save")) {
        this.ticketsrepository.denied.push("assign");
      }

      if (!this.user.permissions.includes("tickets.import")) {
        this.ticketsrepository.denied.push("import");
      }

      if (this.user.permissions.includes("boughtledger.save")) {
        this.options_type.push({ id: "acma", label: "ACMA" })
        this.options_type.push({ id: "adma", label: "ADMA" })
        this.options_type.push({ id: "spcr", label: "SPCR" })
        this.options_type.push({ id: "spdr", label: "SPDR" })
      }

    },
    async ticketsrepository_load(offset, limit, page) {

      this.message = null
      let state = this.ticketsrepository;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      if (limit != 0) { state.busy = true; }

      let variables = {
        offset: state.offset,
        limit: state.limit,
        dateissued: [
          this.issued_at.startDate
            ? this.$moment(this.issued_at.startDate).format("YYYY-MM-DD")
            : null,
          this.issued_at.endDate
            ? this.$moment(this.issued_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        datetravel: [
          this.travel_at.startDate
            ? this.$moment(this.travel_at.startDate).format("YYYY-MM-DD")
            : null,
          this.travel_at.endDate
            ? this.$moment(this.travel_at.endDate).format("YYYY-MM-DD")
            : null,
        ],
        // datetravel: this.datetravel,
        flightno: this.flightno,
        ticketno: this.ticketno.length > 0 ? this.ticketno.join(",") : null,
        blac: this.blac.length > 0 ? this.blac.join(",") : null,
        slac: this.slac.length > 0 ? this.slac.join(",") : null,
        slaclike: this.slaclike,
        passenger: this.passenger,
        routing: this.routing,
        carrier_id: this.carrier_id,

        invoiceno: this.invoiceno.length > 0 ? this.invoiceno.join(",") : null,
        class: this.classid,
        locator: this.locator.length > 0 ? this.locator.join(",") : null,
        eventcode: this.eventcode.length > 0 ? this.eventcode.join(",") : null,
        //eventcode: this.eventcode,
        agent: this.agent,
        branch: this.branch.length > 0 ? this.branch.join(",") : null,
        type: this.type.length > 0 ? this.type.join(",") : null,
        fare_type: this.fare_type.length > 0 ? this.fare_type.join(",") : null,
        fare_indicators: this.fare_indicators.length > 0 ? this.fare_indicators.join(",") : null,
        // iserror: this.iserror,
        state: this.state.length > 0 ? this.state.join(",") : null,
        isqueued: this.isqueued,
        isinvoiced: this.isinvoiced,
        isrelated: this.isrelated,
        isvendorlocator: this.isvendorlocator,
        islive: this.islive,
        hasnotes: this.hasnotes.length == 0 ? null : this.hasnotes.includes('1') ? true : false,
        notes: this.notes,
        // line_ri: this.line_ri,
        line_ri: this.inventory_type == 'empty' ? "null" : this.line_ri,
        inventory_type: this.inventory_type == 'empty' ? null : this.inventory_type,
        mssql: true,
        // dateformat: "DD/MM/YYYY HH:MM:SS",
      };

      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $mssql: Boolean
              $offset: Int
              $limit: Int
              $dateissued: [String]
              $flightno: String
              $ticketno: String
              $datetravel: [String]
              $blac: String
              $slac: String
              $slaclike: String
              $passenger: String
              $routing: String
                 $carrier_id: String
              $line_ri: String
              $invoiceno: String
              $locator: String
              $class: String
              $eventcode: String
              $agent: String
              $branch: String
              $type: String
              $fare_type: String
              $fare_indicators: String
              $state: String
              $isqueued: Boolean
              $isinvoiced: Boolean
              $isrelated: Boolean
              $isvendorlocator: Boolean
              $islive: Boolean
              $inventory_type: String
              $hasnotes: Boolean              
              $notes: String  
              $dateformat: String
            ) {
              tickets(
                mssql: $mssql
                offset: $offset
                limit: $limit
                dateissued: $dateissued
                flightno: $flightno
                ticketno: $ticketno
                datetravel: $datetravel
                passenger: $passenger
                routing: $routing
                carrier_id: $carrier_id
                line_ri: $line_ri
                invoiceno: $invoiceno
                class: $class
                locator: $locator
                blac: $blac
                slac: $slac
                slaclike: $slaclike
                eventcode: $eventcode
                agent: $agent
                branch: $branch
                type: $type
                fare_type: $fare_type
                fare_indicators: $fare_indicators
                state: $state
                isqueued: $isqueued
                isinvoiced: $isinvoiced
                isrelated: $isrelated
                isvendorlocator: $isvendorlocator
                islive: $islive
                inventory_type: $inventory_type
                hasnotes: $hasnotes   
                notes: $notes   
                dateformat: $dateformat
              ) {
                id
                issued_at: dateissued
                dateissued
                carrier_id
                ticketno
                locator
                slac
                yourref
                title
                firstname
                surname
                passenger
                datetravel
                flightno
                class
                seatno
                routing
                # line_ri
                eventcode
                type
                invoiceno
                fare
                tax
                fee
                total
                fare_sell
                blac
                # fare_type
                # queued
                # status
                agent
                # exchangeno
                # originalno
                # lines
                # errors
                # warnings
                branch
                emailed_at
                locked_at
                # created_at
                # created_by
                updated_at
                updated_by
                rows
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE
        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.tickets
        } else {
          state.items = response.data.tickets;
        }

      } catch (error) {
        console.log(error);
      }
      state.busy = false;
    },

    async ticketsrepository_click(a, ss) {

      let state = this.ticketsrepository;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.ticketsrepository_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "refresh":
        case "go":
          this.component = null;
          //   this.dateSelector();
          await this.ticketsrepository_load();
          break;

        case "import":
          this.component = "TicketImport";
          break;
        case "edit":
          this.component = "TicketEdit";
          break;
        case "sync":
          this.component = "TicketsSync";
          break;
        case "errors":
          this.component = "TicketsErrors";
          break;
        case "postgres":
          this.component = "TicketsPG";
          break;
        case "blackhole":
          this.component = "TicketsBlackhole";
          break;
        case "routefix":
          this.component = "TicketsRoutefix";
          break;
        // case "notes":
        //   this.component = "TicketNotes";
        //   break;
        case "inledgers":
          this.component = "TicketsInvoicing";
          break;

        case "etrview":
          this.component = "ETRView";
          break;
        case "etremail":
          this.component = "ETREmail";
          break;

        case "void":
          this.component = "TicketsChange";
          break;

        case "amend":
          this.component = "TicketsAmend";
          break;
        case "assign":
          this.message = ""
          this.component = "TicketsAssign";
          break;

        case "invoice":
          if (ss.length > 0) {
            if (ss[0].invoiceno && ss[0].invoiceno != 'PENDING') {
              this.message = null
              this.component = "TicketsInvoice";
            } else {
              this.message = "Invoice has not been posted yet! Ticket is in <i class='fa fa-hourglass-end text-warning'></i> Zhold awaiting an invoicing action. "
              this.component = null;
            }
          }

          break;
        case "submit":
          if (ss.length > 0) {
            this.component = "TicketsDraft";
          }
          break;
        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async ticketsrepository_select(ss, tools) {

      this.message = null
      let state = this.ticketsrepository;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = [
          "back",
          "save",
          "go",
          "filter",
          "download",
          "clipboard",
          "add",
          "import",
          "sync",
          "inventory",
          "blackhole",
          "routefix",
          "inledgers",
          "charterfix",
          "postgres",
          "assign"
        ];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "notes", "invoice"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm", "errors", "etremail", "submit", "void", "amend", "etrview",];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        // enabled = ["void"];
        // enabled.forEach(function (action, index) {
        //   tool = tools.find((o) => o.action == action);
        //   if (tool) {
        //     tool.disabled = true
        //     for (var i = 0; i < ss.length; ++i) {
        //       if (ss[i].ticketno.slice(0, 2) != 'CH') {
        //         break;
        //       }
        //       tool.disabled = false
        //     }
        //   }
        // });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async deleteit(s) {
      console.log("deleteit", s);

      let state = this.ticketsrepository;
      state.busy = true

      let rows = [];
      s.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      console.log(variables);
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tickets_delete($rows: [Ticket_input]) {
              tickets_delete(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      state.busy = false

      await this.ticketsrepository_load();
    },
    async downloadit() {
      this.busy = true;

      let variables = {
        selected: this.$helpers.prepareforSave(this.selection),
        isgroupetr: this.isgroupetr,
        showseatno: true,
        documentformat: this.documentformat,
        dateformat: "YYYY-MM-DD",
      };
      console.log("download variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets(
              $selected: [Ticket_input]
              $isgroupetr: Boolean
              $showseatno: Boolean
              $documentformat: String
              $dateformat: String
            ) {
              tickets(
                selected: $selected
                isgroupetr: $isgroupetr
                showseatno: $showseatno
                documentformat: $documentformat
                dateformat: $dateformat
              ) {
                documentname
                documentpdf
              }
            }
          `,
          variables,
        });
        if (response.data.tickets.length > 0) {
          try {
            this.fileUpload = JSON.parse(response.data.tickets[0].data);
          } catch (error) {
            // this.fileUpload = {
            //   name: response.data.orders[0].yourref + ".pdf",
            //   data: response.data.orders[0].data,
            // };
          }
          await this.fileUpload_view();
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
  },
};
</script>
